// extracted by extract-css-chunks-webpack-plugin
module.exports = {"sliderWrapper":"eSbSr","animateLeft":"vVDaU","animateRight":"GHOtp","leftArrow":"oYavK","rightArrow":"ttnQ2","mobileSlider":"tAvR1"};